<script>
	import Macy from 'macy'
	import BigPicture from 'bigpicture'

	export let images = []

	let id = `a${Math.floor(Math.random() * 999)}`

	function mounted(container) {
		Macy({
			container,
			margin: 20,
			columns: 3,
			breakAt: {
				900: 2,
				450: 1,
			},
		})
	}

	function openLightbox(e) {
		e.preventDefault()
		BigPicture({
			el: e.target,
			gallery: `#${id}`,
			galleryAttribute: 'href',
		})
	}
</script>

<div use:mounted {id}>
	{#each images as image}
		<div class="ig-item">
			<div
				data-background-image={image.src}
				class="lozad"
				style="padding-bottom:{(image.height / image.width) * 100}%" />
			<a
				href={image.full}
				on:click={openLightbox}
				target="_blank"
				rel="noopener noreferrer"
				data-caption={image.caption}>
				<span class="sr-only">Open image in lightbox</span>
			</a>
		</div>
	{/each}
</div>
